import React from 'react';
import { CalendarIcon } from 'lucide-react';
import Button from '../common/Button';

interface CalendarEmptyStateProps {
  message?: string;
  actionText?: string;
  onAction?: () => void;
}

const CalendarEmptyState: React.FC<CalendarEmptyStateProps> = ({
  message = 'No shifts found for this schedule.',
  actionText,
  onAction,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="w-16 h-16 mb-4 rounded-full bg-gray-100 flex items-center justify-center">
        <CalendarIcon size={32} className="text-gray-400" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{message}</h3>
      <p className="text-gray-500 max-w-md mb-6">
        Create shifts to start building your schedule.
      </p>
      {actionText && onAction && (
        <Button variant="primary" onClick={onAction}>
          {actionText}
        </Button>
      )}
    </div>
  );
};

export default CalendarEmptyState; 